import { useUiComponentsInternationalContext } from '@rsc/static-translations';

export interface ImageProps {
  id: string | number;
  image: {
    altText: string;
    src: string;
  };
}

export interface SelectedMedia {
  id: string | number;
  image: {
    altText: string;
    src: string;
  };
}

export interface CarouselProps {
  images: ImageProps[];
  setSelectedMedia: (media: SelectedMedia) => void;
  selectedMedia: SelectedMedia;
}

export const useCarouselDefaultProps = (): CarouselProps => {
  const { tt } = useUiComponentsInternationalContext();

  return {
    images: [
      {
        id: 1,
        image: {
          altText: tt(s => s.productContainerDeptComponents.imageDefaultAlt),
          src: 'https://placehold.co/800x600',
        },
      },
      {
        id: 2,
        image: {
          altText: tt(s => s.productContainerDeptComponents.imageDefaultAlt),
          src: 'https://placehold.co/800x600',
        },
      },
      {
        id: 3,
        image: {
          altText: tt(s => s.productContainerDeptComponents.imageDefaultAlt),
          src: 'https://placehold.co/800x600',
        },
      },
      {
        id: 4,
        image: {
          altText: tt(s => s.productContainerDeptComponents.imageDefaultAlt),
          src: 'https://placehold.co/800x600',
        },
      },
      {
        id: 5,
        image: {
          altText: tt(s => s.productContainerDeptComponents.imageDefaultAlt),
          src: 'https://placehold.co/800x600',
        },
      },
    ],
    selectedMedia: {
      id: 5,
      image: {
        altText: tt(s => s.productContainerDeptComponents.imageDefaultAlt),
        src: 'https://placehold.co/800x600',
      },
    },
    setSelectedMedia: () => {},
  };
};
